function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { createContext, useContext, useReducer, useRef, useState } from 'react';
export var ApplicationStateContext = /*#__PURE__*/createContext({});
var ApplicationDispatchContext = /*#__PURE__*/createContext({});
export var useApplicationDispatch = () => useContext(ApplicationDispatchContext);
var initialState = {
  selectableLayersHaveRendered: false
};

var ApplicationStateProvider = _ref => {
  var {
    apiUrl,
    apiKey,
    overrides,
    children,
    onTileLoadError
  } = _ref;
  var stateRef = useRef(null);
  var [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'MARK_SELECTABLE_LAYERS_AS_RENDERED':
        return _objectSpread(_objectSpread({}, state), {}, {
          selectableLayersHaveRendered: true
        });

      default:
        return state;
    }
  }, initialState);
  var [undoFeatureStack, setUndoFeatureStack] = useState({
    features: [],
    pointer: -1
  });
  var [autofillFeatures, setAutofillFeatures] = useState([]);
  var selectedFeatureRef = useRef(null);
  var highlightedFeatureRef = useRef(null); // Needed to read state values from within an OpenLayers event handler.
  // Used in src/components/LayerSwitcher

  stateRef.current = state;
  return /*#__PURE__*/React.createElement(ApplicationStateContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      selectedFeatureRef,
      highlightedFeatureRef,
      apiUrl,
      apiKey,
      stateRef,
      overrides,
      onTileLoadError,
      undoFeatureStack,
      setUndoFeatureStack,
      autofillFeatures,
      setAutofillFeatures
    })
  }, /*#__PURE__*/React.createElement(ApplicationDispatchContext.Provider, {
    value: dispatch
  }, children));
};

export default ApplicationStateProvider;